import type { JSX } from '@builder.io/qwik';
import { component$, Slot, useContextProvider } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { CardContext } from '~/contexts/CardContext';
import type { GalleryCardsBlockInterface } from '~/types/AppData/PageBuilder/GalleryCardsBlockInterface';

const containerClasses = cva('grid gap-x-4 gap-y-5 md:gap-5', {
  variants: {
    columns: {
      '3': 'md:grid-cols-3',
      '4': 'md:grid-cols-4',
      '5': 'md:grid-cols-5',
    },
    mobileColumns: {
      '1': 'grid-cols-1',
      '2': 'grid-cols-2',
    },
  },
});

export default component$<GalleryCardsBlockInterface['props']>(
  ({ galleryTitle, columns, card, mobileColumns }): JSX.Element => {
    useContextProvider(CardContext, {
      ...card,
      rows: parseInt(columns ?? '3'),
    });
    return (
      <div class='page-builder-item flex justify-center flex-col mx-auto px-6 max-w-[1060px] mb-5'>
        {galleryTitle && (
          <h2 class='text-center font-group-huge mb-6'>{galleryTitle}</h2>
        )}
        <div class={containerClasses({ columns, mobileColumns })}>
          <Slot />
        </div>
      </div>
    );
  }
);
